var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ZhoeqGRlU4N04-bRnjPUe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["caribeeats-dot-com-frontend-javascript-nextjs@caribesolutions-inc"]={id:"ZhoeqGRlU4N04-bRnjPUe"};
      